module.exports = __webpack_public_path__ + "assets/accc2bc04c5527fa5e7b96e267dadcc6.svg";